import React from 'react';
import PropTypes from 'prop-types';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import ShippingOld from './ShippingOld';
import ShippingNew from './ShippingNew';

const Shipping = props => {
  const postHogFlag = usePostHogFeatureFlag('CheckoutAVS');

  return (
    <div>
      {postHogFlag === 'test' ? (
        <ShippingNew {...props} />
      ) : (
        <ShippingOld {...props} />
      )}
    </div>
  );
};

Shipping.propTypes = {
  disableSubmitBtn: PropTypes.bool,
  shipping: PropTypes.object,
  submitShippingForm: PropTypes.func.isRequired,
  updateShipping: PropTypes.func.isRequired,
  validateFormOnLoad: PropTypes.bool,
  isTradeUser: PropTypes.bool,
  showShippingSuggestionModal: PropTypes.bool,
  closeShippingSuggestionModal: PropTypes.func,
  validateShippingAddress: PropTypes.func,
  handleSelectRecommendedShipping: PropTypes.func,
  shippingAddressSuggestion: PropTypes.object,
};

export default Shipping;
